function formatPrice(price) {  
  price = parseFloat(price).toFixed(2);
  return "$"+(new Intl.NumberFormat('es-AR', {})).format(price)
}

function formatPriceNumber(price) {  
  return parseFloat(parseFloat(price).toFixed(2));  
}

function formatDateString(date_string) {
  //Format "yyyy-mm-dd" to "dd/mm/yyyy"
  if(date_string === null) return "-";
  const date = new Date(date_string);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;  
}

function formatDateShort(date_string) {
  //Format "yyyy-mm-dd" to "12/Sept"
  if(date_string === null) return "-";
  
  const months = [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
    'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'
  ];
  
  const date = new Date(date_string);
  const day = date.getDate();
  const monthName = months[date.getMonth()];
  
  return `${day}/${monthName}`;
}

export const formatUtils = {
  formatPrice,  
  formatPriceNumber,
  formatDateString,
  formatDateShort,
};
